import { useEffect, useState } from "react";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import LoadingWheel from "../../components/shared/LoadingWheel";
import { useParams } from "react-router-dom";
import useCategorySingle from "../../data/Category/useCategorySingle";
import CategoryDetails from "../../components/CategoryEditor/CategoryDetails";


export default function EditCategory() {
  const { categoryId } = useParams();
  const { setInfo } = usePageNameContext();
  const { category, create, update } = useCategorySingle(categoryId);
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (!category.isLoading) {
      setIsLoading(false);
    }
  }, [category.isLoading, category.data])

  useEffect(() => {
    setInfo({
      name: "Category Editor",
      desc: "Changes made here will be reflected in every customers database",
      pageTitle: "Categories",
    });
  }, []);

  useEffect(() => {
    if(open) return;

    // navigate back to categories page when modal is closed
    window.location.href = "/categories";

  }, [open]);

  if (isLoading) {
    return <LoadingWheel />
  }

  return (
    <div>

      <div className="flex justify-between items-center">
        <h1 className="text-xl">{`${!category ? "Add a category" : ""}`}</h1>
        {/* {category && <ButtonInput label="View Parts" isSubmit={false} onClick={() => window.open(`/parts-editor/${category?.data?.data.id}`, "_blank", "noreferrer")} classes={undefined} />} */}
      </div>
      <div className="mt-4">
        <CategoryDetails category={category.data} update={update} create={create} setOpen={setOpen} />
        <br />


        {/* {category &&
          <div className="w-full mt-4 space-y-4">
            <h1 className="text-lg">Part Mappings <span className="text-sm"> - Smallest number is highest priority</span></h1>
            <hr />
            {category?.data?.data.partMappings.map((mapping) => (
              <MappingRow key={mapping.id} mapping={mapping} categoryId={category.data.data.id} />
            ))}
            <MappingRow mapping={null} categoryId={category.data?.data.id!} />
          </div>
        } */}
      </div>

    </div>
  );
};
